import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../login/login.css";

export default function Login() {
    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const [logoutReason, setLogoutReason] = useState("");
    const navigate = useNavigate();

    // 🧠 Show "Session expired" message if stored in localStorage
    useEffect(() => {
        const message = localStorage.getItem("logoutReason");
        if (message) {
            setLogoutReason(message);
            localStorage.removeItem("logoutReason");
        }
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setError(""); // clear error when typing
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch("http://localhost:4000/api/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.message || "Login failed");
            }

            // ✅ Save token and user info
            localStorage.setItem("token", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));

            // ✅ Toast success
            toast.success(`Welcome back, ${data.user.firstName || "friend"}! 🎉`, {
                position: "top-center",
                autoClose: 2500,
            });

            // ✅ Redirect after toast
            setTimeout(() => navigate("/profile"), 3000);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <h2 className="login-title">Welcome Back 👋</h2>
                {logoutReason && <div className="logout-reason">{logoutReason}</div>}

                <form className="login-form" onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="email">Email:</label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Email"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="password">Password:</label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            placeholder="Password"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    {error && <div className="error-msg">{error}</div>}
                    <button type="submit" className="login-button">Log In</button>

                    <div className="form-footer">
                        <span>
                            Don't have an account yet? <a href="/signup">Sign up here</a>
                        </span>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </div>
    );
}